module.exports = __webpack_public_path__ + "static/media/Ragnar Lothbrok 2.b0e5409e.jpg";